import Flash from "lib/flash"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // could technically port all the existing flash message code
    // into here, but this is all we really need to get it working
    Flash.bindServerFlash()
  }
}
